export default "__VITE_ASSET__DU1H7JIF__"